import components from '../algolia';
import 'bootstrap-sass/assets/javascripts/bootstrap/carousel';

export default {
  name: 'FeaturedBlogPosts',
  components,
  data() {
    return {
      indexName: this.$algolia.indexPrefix + 'blog_posts',
      filterString: '(featured:true)'
    };
  }
};
